import React, { ChangeEvent, useEffect, useRef } from 'react'

import { useField } from '@unform/core'
import classNames from 'classnames'
import { InputArquivoProps } from 'src/componentes/input/input-arquivo'

import { InputArquivoComentario } from './input'
import { Componente, Erro } from './styles'
import { InputArquivoRef } from './tipos'

export const ComentarioTopicoArquivoInput: React.FC<InputArquivoProps> = ({
  name,
  className,
  acaoAoAlterar,
  ...rest
}) => {
  const inputRef = useRef<InputArquivoRef>(null)
  const {
    fieldName,
    registerField,
    defaultValue,
    error,
    clearError
  } = useField(name)

  useEffect(() => {
    registerField<File | string>({
      name: fieldName,
      ref: inputRef.current,
      getValue: () => {
        return inputRef.current?.getValue() ?? null
      },
      setValue: (_, value) => {
        inputRef.current?.setValue(value)
      },
      clearValue: () => {
        inputRef.current?.setValue(null)
        inputRef.current?.limpar()
      }
    })
  }, [fieldName, registerField])

  return (
    <Componente
      theme={{
        ComErro: !!error
      }}
      className={classNames(className)}
    >
      <InputArquivoComentario
        ref={inputRef}
        name={name}
        valorPadrao={defaultValue}
        comErro={!!error}
        acaoAoAlterar={(e: ChangeEvent<HTMLInputElement>) => {
          clearError()
          if (acaoAoAlterar) acaoAoAlterar(e)
        }}
        className={classNames({
          error
        })}
        tiposAceitos={[
          '.png',
          '.jpg',
          '.jpeg',
          '.pdf',
          '.doc',
          '.docx',
          '.ppt',
          '.pptx',
          '.xls',
          '.xlsx',
          '.odt',
          '.odp',
          '.ods'
        ]}
        {...rest}
      />
      <Erro id={`erro-${rest.id}`}>{error}</Erro>
    </Componente>
  )
}
